import type { ScreenerColumn } from "epsm-api-types/models";
import { formatValue } from "@/components/widgets/helpers/FormattingHelpers";
import { getUnixTime } from "@/lib/utils";

export const columnValueFormatter = (
	value: unknown,
	column: ScreenerColumn,
) => {
	if (column.type === "date") {
		let formattedValue = value;
		if (value instanceof Date) {
			formattedValue = value.toISOString();
		} else if (typeof value !== "string") {
			return "";
		}

		return formatValue(
			getUnixTime(formattedValue as string),
			column.type,
			column.options,
		);
	}

	return formatValue(value, column.type, column.options);
};
